// extracted by mini-css-extract-plugin
export default {"button":"WhatsAppButton_button__iwwZC","buttonText":"WhatsAppButton_buttonText__rGPgg","icon":"WhatsAppButton_icon__9ZCb7","arrowIcon":"WhatsAppButton_arrowIcon__ArB3t"};